import { SearchTableQuery } from 'owa-mail-list-search';
import { PerformanceDatapoint } from 'owa-analytics';
import { MailListRowDataType, TableQuery } from 'owa-mail-list-store';
import { ActionSource } from 'owa-mail-store';
import { SearchScope, SearchScopeKind } from 'owa-search-service';
import { action } from 'satcheljs';

export interface LoadTableViewFromSearchTableQueryActionMessage {
    searchTableQuery: TableQuery;
    searchEndToEndPerformanceDatapoint: PerformanceDatapoint;
    actionSource: ActionSource;
}

/**
 * Dispatched to clear current search scope (i.e. change it to broadest scope).
 * Action message provides option to kick off search after scope is changed.
 *
 * Currently, this action is only used in MailListEmptyViewState component.
 */
export const clearSearchScope = action(
    'CLEAR_SEARCH_SCOPE',
    (actionSource: string, shouldStartSearch: boolean, searchScopeKind: SearchScopeKind) => ({
        actionSource,
        shouldStartSearch,
        searchScopeKind,
    })
);

export const loadMessageSuggestionIntoTable = action(
    'LOAD_MESSAGE_SUGGESTION_INTO_TABLE',
    (
        actionSource: string,
        row: MailListRowDataType,
        searchTableQuery: SearchTableQuery,
        referenceId: string,
        traceId: string,
        itemPartId?: string
    ) => ({
        actionSource,
        row,
        searchTableQuery,
        referenceId,
        traceId,
        itemPartId,
    })
);

export const loadTableViewFromSearchTableQuery = action(
    'LOAD_TABLE_VIEW_FROM_SEARCH_TABLE_QUERY',
    (
        searchTableQuery: TableQuery,
        searchEndToEndPerformanceDatapoint: PerformanceDatapoint,
        actionSource: ActionSource
    ) => ({
        searchTableQuery: searchTableQuery,
        searchEndToEndPerformanceDatapoint: searchEndToEndPerformanceDatapoint,
        actionSource: actionSource,
    })
);

export const removeSearchTableFromStore = action(
    'REMOVE_SEARCH_TABLE_FROM_STORE',
    (tableViewId: string) => ({
        tableViewId,
    })
);

/**
 * This action is to be dispatched after search is exited and we need
 * to re-select the previous node the user was on before entering into
 * their search session.
 */
export const selectPreviousNode = action('SELECT_PREVIOUS_NODE', (actionSource: string) => ({
    actionSource: actionSource,
}));

export const setStaticSearchScope = action(
    'SET_STATIC_SEARCH_SCOPE',
    (searchScope: SearchScope) => ({
        searchScope,
    })
);

export const startSearchWithCategory = action(
    'START_SEARCH_WITH_CATEGORY',
    (actionSource: string, categoryName: string) => ({
        actionSource: actionSource,
        categoryName: categoryName,
    })
);
